import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import CampaignTemplatesTab from './CampaignTemplatesTab.tsx';
import './index.css';
import ProtectedRoute from '../Routes/ProtectedRoute.jsx';
import { isPlatformSuperAdmin } from '../../utils/isPlatformSuperAdmin.ts';
import UserInfo from '../LeadWebForm/userInfo.jsx';

const Settings = () => {
  const canAccessSettings = isPlatformSuperAdmin(UserInfo);
  return (
    <Routes>
      <Route
        index
        element={
          <ProtectedRoute
            element={<Navigate to="campaign-templates" replace />}
            permissionGranted={canAccessSettings}
          />
        }
      />
      <Route
        path="campaign-templates"
        element={
          <ProtectedRoute
            element={<CampaignTemplatesTab />}
            permissionGranted={canAccessSettings}
          />
        }
      />
      <Route
        path="*"
        element={
          <ProtectedRoute
            element={<Navigate to="campaign-templates" replace />}
            permissionGranted={canAccessSettings}
          />
        }
      />
    </Routes>
  );
};

export default Settings;
